angular.module('app')
	.controller('HandleContractsCtrl', function (
		$scope,
		$contractService,
		$modalService,
		$download
	) {
		var self = this

		$scope.viewIndex = "inner-view-show-contracts"

		$scope.documents = null

		$scope.flags = {
			noContracts: null
		}

		$scope.initialize = function () {
			/** for the view to use it */
			$scope.$contractService = $contractService
			$scope.$modalService = $modalService
			$scope.orderDetailsLoader = [];
			/** fetch contracts **/
			getAllSignedContracts()

		}

		var getAllSignedContracts = function () {
			$contractService.getSignedArchive()
				.then(function (list) {
					$scope.contractList = list
					/** empty table */
					if (!$scope.contractList.length) {
						$scope.flags.noContracts = false
					} else {
						$scope.flags.noContracts = true
					}
				})
		}

		$scope.orderDetails = function (contractSigned, index) {
			$scope.orderDetailsLoader[index] = true;
			$contractService
				.contractSignedDocs(contractSigned)
				.then(function (documents) {
					$scope.orderDetailsLoader[index] = false;
					console.log('orderDetails returned!', documents)
					$scope.documents = documents;
					$modalService.openModal('signedcontract-detail')
				})
				.catch(function (error) {
					$scope.orderDetailsLoader[index] = false;
				})
		}



		//$modalService.openModal('contract-detail-modal.html')

		$scope.downloadSignedDocument = function (document) {

			var url = '/simulator/contract/downloadSignedDocument/service-infos/';

			var input = {
				downloadKey: document.downloadKey
			}
			$download.getGenericDownload(url, input)
				.then(function (response) {
					console.log(response)
				})

		}


	});